import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAdImportInitiated.meta';

export const useTrackAdImportInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackAdImportInitiated = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackAdImportInitiated };
};
